// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jGkyK8MzL1OW1FuPBBew {
  width: 100%;
  height: 32px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/componentes/Tabela/TabelaCabecalho/TabelaCabecalho.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,2CAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AACJ","sourcesContent":[".headerContainer {\r\n    width: 100%;\r\n    height: 32px;\r\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);\r\n    border-top-left-radius: 8px;\r\n    border-top-right-radius: 8px;\r\n    background-color: #fff;\r\n}"],"sourceRoot":""}]);
// Exports
export var headerContainer = `jGkyK8MzL1OW1FuPBBew`;
export default ___CSS_LOADER_EXPORT___;
